// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/build/release-cloudweb-14955-130-1-0.202303241329/" + chunkId + ".js";
};